import { itemsCol, layerHas } from '../../shared/array-types';

/** Shared cast refusal and charge-style hint, using each surface's held-layer reader. */
export function spellLockReason(caster: unknown, item: unknown, has = layerHas): string | null {
    return itemsCol(item, 'item_type') === 'spell' && has(caster, 'spell_locked')
        ? 'While spell locked you cannot cast any spells!' : null;
}
